import { toString, round, isNaN } from "lodash"
import { create, all } from "mathjs"

const formatRound = value => {
  if (isNaN(toString(round(value))?.length)) {
    return 0
  } else {
    if (toString(round(value))?.length <= 2) {
      return value
    } else if (toString(round(value))?.length === 3) {
      return round(value, -2)
    } else if (toString(round(value))?.length === 4) {
      return round(value, -3)
    } else if (toString(round(value))?.length === 5) {
      return round(value, -4)
    } else if (toString(round(value))?.length === 6) {
      return round(value, -5)
    } else if (toString(round(value))?.length === 7) {
      return round(value, -6)
    }
  }
}

const getNumericalValue = (value, formatWithSpace) => {
  if (formatWithSpace) return value.toLocaleString()
  return value
}

const sortDesc = (a, b) => b - a

export const generateLegendValue = (data, value, map, colors, showSpaceForThousand) => {
  const pageSelect = window.location?.pathname
  if (pageSelect.includes("62b4696e13c9063ba374f808")) {
    const legendValue = [
      {
        name: "more than 2%",
        firstValue: 2,
        secondValue: 999999999999,
        color: "#E74C3C",
        radius: "10",
      },
      {
        name: "between 1% and 2%",
        firstValue: 1,
        secondValue: 2,
        color: "#F1C40F",
        radius: "8",
      },
      {
        name: "less than 1%",
        firstValue: 0,
        secondValue: 1,
        color: "#27AE60",
        radius: "6",
      },
    ]

    return legendValue
  } else {
    if (data.length && value) {
      const dataValue = data?.map(item => {
        return item[value]
      })

      const config = {}
      const math = create(all, config)
      const quantilesData = math.quantileSeq(dataValue, 5)
      const quantilesDataOrder = quantilesData.sort(sortDesc)

      const legendValue =
        map === "franceRegNew" || map === "franceReg"
          ? [
              {
                name:
                  "+ de " +
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[0] || 0) * 5,
                    showSpaceForThousand
                  ),
                firstValue: formatRound(quantilesDataOrder?.[0] || 0) * 5,
                secondValue: 999999999999,
                color: colors[0],
                radius: "12",
              },
              {
                name:
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[1] || 0) * 5,
                    showSpaceForThousand
                  ) +
                  " à " +
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[0] || 0) * 5,
                    showSpaceForThousand
                  ),
                firstValue: formatRound(quantilesDataOrder?.[1] || 0) * 5,
                secondValue: formatRound(quantilesDataOrder?.[0] || 0) * 5,
                color: colors[1],
                radius: "10",
              },
              {
                name:
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[2] || 0) * 5,
                    showSpaceForThousand
                  ) +
                  " à " +
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[1] || 0) * 5,
                    showSpaceForThousand
                  ),
                firstValue: formatRound(quantilesDataOrder?.[2] || 0) * 5,
                secondValue: formatRound(quantilesDataOrder?.[1] || 0) * 5,
                color: colors[2],
                radius: "8",
              },
              {
                name:
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[3] || 0) * 5,
                    showSpaceForThousand
                  ) +
                  " à " +
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[2] || 0) * 5,
                    showSpaceForThousand
                  ),
                firstValue: formatRound(quantilesDataOrder?.[3] || 0) * 5,
                secondValue: formatRound(quantilesDataOrder?.[2] || 0) * 5,
                color: colors[3],
                radius: "6",
              },
              {
                name:
                  "- de " +
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[3] || 0) * 5,
                    showSpaceForThousand
                  ),
                firstValue: 0,
                secondValue: formatRound(quantilesDataOrder?.[3] || 0) * 5,
                color: colors[4],
                radius: "4",
              },
            ]
          : [
              {
                name:
                  "+ de " +
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[0] || 0),
                    showSpaceForThousand
                  ),
                firstValue: formatRound(quantilesDataOrder?.[0] || 0),
                secondValue: 999999999999,
                color: colors[0],
                radius: "11",
              },
              {
                name:
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[1] || 0),
                    showSpaceForThousand
                  ) +
                  " à " +
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[0] || 0),
                    showSpaceForThousand
                  ),
                firstValue: formatRound(quantilesDataOrder?.[1] || 0),
                secondValue: formatRound(quantilesDataOrder?.[0] || 0),
                color: colors[1],
                radius: "9",
              },
              {
                name:
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[2] || 0),
                    showSpaceForThousand
                  ) +
                  " à " +
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[1] || 0),
                    showSpaceForThousand
                  ),
                firstValue: formatRound(quantilesDataOrder?.[2] || 0),
                secondValue: formatRound(quantilesDataOrder?.[1] || 0),
                color: colors[2],
                radius: "7",
              },
              {
                name:
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[3] || 0),
                    showSpaceForThousand
                  ) +
                  " à " +
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[2] || 0),
                    showSpaceForThousand
                  ),
                firstValue: formatRound(quantilesDataOrder?.[3] || 0),
                secondValue: formatRound(quantilesDataOrder?.[2] || 0),
                color: colors[3],
                radius: "5",
              },
              {
                name:
                  "- de " +
                  getNumericalValue(
                    formatRound(quantilesDataOrder?.[3] || 0),
                    showSpaceForThousand
                  ),
                firstValue: 0,
                secondValue: formatRound(quantilesDataOrder?.[3] || 0),
                color: colors[4],
                radius: "3",
              },
            ]

      return legendValue
    } else if (colors.length) {
      const legendValue = [
        {
          name: "+ de " + getNumericalValue(8000, showSpaceForThousand),
          firstValue: 8001,
          secondValue: 999999999999,
          color: colors[0],
          radius: "10",
        },
        {
          name:
            getNumericalValue(5000, showSpaceForThousand) +
            " à " +
            getNumericalValue(8000, showSpaceForThousand),
          firstValue: 5001,
          secondValue: 8000,
          color: colors[1],
          radius: "8",
        },
        {
          name:
            getNumericalValue(1000, showSpaceForThousand) +
            " à " +
            getNumericalValue(5000, showSpaceForThousand),
          firstValue: 1001,
          secondValue: 5000,
          color: colors[2],
          radius: "6",
        },
        {
          name:
            getNumericalValue(500, showSpaceForThousand) +
            " à " +
            getNumericalValue(1000, showSpaceForThousand),
          firstValue: 501,
          secondValue: 1000,
          color: colors[3],
          radius: "4",
        },
        {
          name: "-" + getNumericalValue(500, showSpaceForThousand),
          firstValue: 0,
          secondValue: 500,
          color: colors[4],
          radius: "2",
        },
      ]

      return legendValue
    } else {
      const legendValue = [
        {
          name: "+ de " + getNumericalValue(8000, showSpaceForThousand),
          firstValue: 8001,
          secondValue: 999999999999,
          color: "#68B8DC",
          radius: "10",
        },
        {
          name:
            getNumericalValue(5000, showSpaceForThousand) +
            " à " +
            getNumericalValue(8000, showSpaceForThousand),
          firstValue: 5001,
          secondValue: 8000,
          color: "#6794DC",
          radius: "8",
        },
        {
          name:
            getNumericalValue(1000, showSpaceForThousand) +
            " à " +
            getNumericalValue(5000, showSpaceForThousand),
          firstValue: 1001,
          secondValue: 5000,
          color: "#6771DC",
          radius: "6",
        },
        {
          name:
            getNumericalValue(500, showSpaceForThousand) +
            " à " +
            getNumericalValue(1000, showSpaceForThousand),
          firstValue: 501,
          secondValue: 1000,
          color: "#8067DC",
          radius: "4",
        },
        {
          name: "-" + getNumericalValue(500, showSpaceForThousand),
          firstValue: 0,
          secondValue: 500,
          color: "#A367DC",
          radius: "2",
        },
      ]

      return legendValue
    }
  }
}

/**
 * Détection du format du code postal
 * @param {String} cp
 * @returns code postal format 2 chiffres (ex: 75)
 */
export const transformCP = cp => {
  if (cp) {
    const toString = cp?.toString()
    if (toString.length === 1) return "0" + toString
    else if (toString.length === 4) return "0" + toString.slice(0, 1)
    else if (toString.length === 5) return toString.slice(0, 2)
    else return toString
  } else return ""
}

export const haveSameValue = (arr1, arr2) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false
  const values1 = arr1.map(obj => obj?.value)
  const values2 = arr2.map(obj => obj?.value)

  return JSON.stringify(values1) === JSON.stringify(values2)
}

export const getNewFilterValues = (filterList, filterType, path, newValues) => {
  if (filterType === "multiSelect") {
    const valuesAlreadyFilteredPosition = path.codePostal.map(cp =>
      filterList.findIndex(({ value }) => value === cp)
    )
    if (valuesAlreadyFilteredPosition.every(pos => pos !== -1)) {
      // remove value from filter
      valuesAlreadyFilteredPosition.filter(pos => pos !== -1)
      valuesAlreadyFilteredPosition.sort((a, b) => b - a)

      for (const index of valuesAlreadyFilteredPosition) {
        filterList.splice(index, 1)
      }
      return filterList
    } else {
      // add value to filter
      if (Array.isArray(newValues)) {
        filterList.push(...newValues)

        return filterList
      } else {
        filterList.push(newValues)

        return filterList
      }
    }
  } else {
    // if singleSelect
    if (Array.isArray(newValues)) {
      if (haveSameValue(filterList, newValues)) return []
      return newValues
    } else {
      if (haveSameValue(filterList, [newValues])) return []
      return [newValues]
    }
  }
}
